<template>
  <div class="main">
    <question-type></question-type>
    <survey :surveyData="surveyData"></survey>
    <setting></setting>
  </div>
</template>

<script>
import QuestionType from './components/question-type'
import Survey from './components/survey'
import Setting from './components/setting/index'
export default {
  data() {
    return {}
  },
  computed: {
    surveyData() {
      return this.$store.state.survey.surveyBody
    }
  },
  components: {
    QuestionType,
    Survey,
    Setting
  }
}
</script>

<style lang="less" scoped>
.main {
  position: relative;
  box-sizing: border-box;
  padding: 64px 0 0;
  min-width: 1130px;
  height: 100%;
}
</style>
